export class EndpointResource {
  static readonly sessionEndpoint = 'accesscontrol/token-session';
  static readonly preAuthEndpoint = 'tokenizacion/3ds/pre';
  static readonly authEndpoint = 'tokenizacion/3ds/auth';
  static readonly postAuthEndpoint = 'tokenizacion/3ds/post';
  static readonly enrollEndpoint = 'tokenizacion/enroll/visa';
  static readonly errorLogEndpoint = 'tokenizacion/log/web';
}